import { TransportStates } from '@arpeggi/shared'
import { observer } from 'mobx-react-lite'
import { clone } from 'mobx-state-tree'
import { useEffect } from 'react'
import { useTreeState } from '../../../stores/Root'
import { Row, TooltipIconButton } from '../../core/Components'
import { StopIcon } from '../../core/icons'
import { blue5, gray12 } from '../../platform/color'
import { PlayButtonSVG } from '../../player/Icons'

const ClipEditorControls = () => {
  const { studio, alternatePlayer } = useTreeState()
  const currentClip = studio.song.getClipByID(studio.selectedClipIDs[0])

  useEffect(() => {
    alternatePlayer.initialize()
  }, [])

  useEffect(() => {
    if (alternatePlayer.playheadVisiblePositionInTicks > alternatePlayer.repeatEnd) {
      alternatePlayer.pause()
    }
  }, [alternatePlayer.playheadVisiblePositionInTicks])

  const onClickPlay = () => {
    if (alternatePlayer.transportState === TransportStates.PLAYING) return alternatePlayer.pause()
    else {
      alternatePlayer.reset()
      alternatePlayer.song.updateTempo(studio.song.tempo)
      alternatePlayer.addAudioStem()
      const clipClone = clone(currentClip)
      alternatePlayer.repeatStart = clipClone.startInComposition48n
      alternatePlayer.repeatEnd = clipClone.endInComposition48n
      alternatePlayer.setPlayheadStartPositionTicks(alternatePlayer.repeatStart)
      alternatePlayer.addClipToStem(0, clipClone)
      alternatePlayer.forceRender()
      alternatePlayer.fetchSamplesForCurrentSongAsync().then(() => {
        alternatePlayer.play()
      })
    }
  }

  const onClickStop = () => alternatePlayer.stop()

  const onClickRepeat = () => alternatePlayer.toggleRepeatSection()

  if (studio.selectedClipIDs.length !== 1) return null
  return (
    <Row verticalCenter horizontalCenter>
      {currentClip && (
        <>
          <TooltipIconButton
            tooltipText={
              alternatePlayer.transportState === TransportStates.PLAYING ? 'Pause' : 'Preview'
            }
            onClick={onClickPlay}
            css={{ marginRight: '10px' }}
          >
            <PlayButtonSVG
              size="24px"
              fill={alternatePlayer.transportState === TransportStates.PLAYING ? blue5 : gray12}
            />
          </TooltipIconButton>
          <TooltipIconButton tooltipText="Stop" onClick={onClickStop} css={{ marginRight: '10px' }}>
            <StopIcon height="16px" width="16px" />
          </TooltipIconButton>
          {/* TODO: Add support for loop playback back in */}
          {/* <TooltipIconButton tooltipText="Loop" onClick={onClickRepeat}>
            <RepeatIcon
              height="16px"
              width="16px"
              style={{ color: alternatePlayer.repeatSection ? blue5 : gray12 }}
            />
          </TooltipIconButton> */}
        </>
      )}
    </Row>
  )
}

export default observer(ClipEditorControls)
